export const TOTAL_TRIAL_STEPS = 3;

export const TRIAL_STEPS = {
  YOUR_DETAIL: {
    step: 1,
    title: 'Your Details',
    subtitle: 'We need a few details about you before we get started',
  },
  ORG_DETAIL: {
    step: 2,
    title: 'Your Organisation',
    subtitle: 'This will help us personalise your trial',
  },
  TERMS_OF_USE: {
    step: 3,
    title: 'Terms Of Use',
    subtitle: 'Please read the terms of service below',
  },
  SUBMIT: {
    step: 4,
  },
};

export enum TrialStepsEnum {
  YOUR_DETAIL = 'YOUR_DETAIL',
  ORG_DETAIL = 'ORG_DETAIL',
  TERMS_OF_USE = 'TERMS_OF_USE',
  SUBMIT = 'SUBMIT',
}

export const VOLABY_REGION = [
  { value: 'au', label: 'Australia' },
  { value: 'nz', label: 'New Zealand' },
  { value: 'us', label: 'United States' },
  { value: 'uk', label: 'United Kingdom' },
  { value: 'ca', label: 'Canada' },
  { value: 'eu', label: 'Europe' },
  { value: 'ap', label: 'Asia Pacific' },
  { value: 'global', label: 'Other' },
];

export const VOLS_NO_OPTION = ['0 - 50', '50 - 100', '100 - 200', '200 - 400', '400 - 600', '600+'];
export const HEARD_FROM_OPTIONS = ['Word of Mouth', 'Volaby Voice', 'Google', 'Facebook', 'Instagram', 'LinkedIn', 'Newspaper', 'Other'];
